import { render, staticRenderFns } from "./contact-list.vue?vue&type=template&id=15672976&"
import script from "./contact-list.vue?vue&type=script&lang=js&"
export * from "./contact-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports